import { render, staticRenderFns } from "./HeroSection.vue?vue&type=template&id=871eae22&scoped=true&"
import script from "./HeroSection.vue?vue&type=script&lang=js&"
export * from "./HeroSection.vue?vue&type=script&lang=js&"
import style0 from "./HeroSection.vue?vue&type=style&index=0&id=871eae22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871eae22",
  null
  
)

export default component.exports